<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="工资单号、名称"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="salary_record_order_id"
          label="发薪单号"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="salary_record_name"
          label="名称"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="扣缴义务人">
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_name"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="money"
          label="发放金额"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          prop="pay_time"
          label="发放时间"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                state.selectItem = row;
                state.showDetail = true;
              "
            >
              查看工资单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <el-dialog
    v-model="state.showDetail"
    :title="
      state.selectItem.customer_name + ' ' + state.selectItem.salary_record_name
    "
    width="60%"
    align-center
    :key="state.selectItem.id"
  >
    <c_Detail
      @close="
        state.showDetail = false;
        onLoad();
      "
      :id="state.selectItem.id"
      :employee_id="props.employee_id"
    ></c_Detail>
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_salaryrecord } from "@/http/employee";
import c_Detail from "./Detail.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    employee_id: Number,
  },
  components: {
    c_Detail,
  },
  setup(props) {
    const state = reactive({ ...new InitFormData(), selectItem: {} });
    onMounted(() => {
      state.params.employee_id = props.employee_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      employee_salaryrecord(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
